import { FiscalSettings } from './FiscalSettings';

/** Settings, certificates, logo, API tokens (Task 15). */
export function FiscalSettingsPage() {
  return <FiscalSettings />;
}
